import { Pipe, PipeTransform } from '@angular/core';
import { ConstantsQualityLevel } from '../constants/constants.interface';
import { ConstantsService } from '../constants/constants.service';

@Pipe({
  name: 'qualityLevel'
})
export class QualityLevelPipe implements PipeTransform {

  /** Status constants. */
  qualityLevels: ConstantsQualityLevel[];

  constructor(
    private constantsService: ConstantsService
  ) { }

  /**
   * Convert quality level notation.
   *
   * Example:
   *  - Convert id to displayName;
   *  - Convert value to id.
   *
   * @note Because of how the legacy ui-router works, Constants may not always be
   *  available in the constructor. When migrated, move the quality level setter.
   *
   * @param value The element's quality level.
   * @param i Input type as key.
   * @param [o=displayName] Output type as key.
   * @param [def] Optional default value.
   * @returns Converted quality level.
   */
  transform<Key extends keyof ConstantsQualityLevel>(
    value: ConstantsQualityLevel[Key], i: Key, o: keyof ConstantsQualityLevel = 'displayName', def?: any
  ): ConstantsQualityLevel[keyof ConstantsQualityLevel] {
    const input = i || '_id';
    this.qualityLevels = this.qualityLevels || this.constantsService.getQualityLevels();
    const status = this.qualityLevels.find(s => s[input] === value);

    return status && status[o] || def || '';
  }

}
